import { locateOutline } from 'ionicons/icons';
import { ReactElement, useCallback, useState } from 'react';
import { useFlipCardContext } from '../../../../../../components/ui/flip-card-context';
import { getLocalizedText } from '../../../../../../i18n/i18n.utils';
import { QNear, Waypoint } from '../../../../../../util/machine-variable.utils';
import { useFlowServices } from '../../../hook/flow-service.hooks';
import { useUpdateFlowItemFormOnWaypointCapture } from '../../../hook/waypoint-capture.hooks';
import { FlowItem } from '../../../model/flow.types';
import { CaptureWaypointSpinner } from '../../button/capture-waypoint-button';
import {
  FineTuneOnUpdatePointCallback,
  FineTuneOnUpdatePointOptions,
  FlowItemFineTune,
} from '../fine-tune/flow-item-fine-tune';
import {
  FlowItemBaseAction,
  FlowItemBaseActionCommonProps,
} from './flow-item-base-action';

interface FlowItemTouchUpPointActionProps
  extends FlowItemBaseActionCommonProps {
  item: FlowItem;
  stopProgramFirst?: boolean;
}

const FlowItemTouchUpPointAction = (
  props: FlowItemTouchUpPointActionProps
): ReactElement => {
  const { disabled, item, stopProgramFirst } = props;

  const { setBack, showBack } = useFlipCardContext();
  const { flowAnalyticService } = useFlowServices();

  const [isAwaitingCapture, setWaitForCapture] = useState<boolean>(false);

  const onCapture = useUpdateFlowItemFormOnWaypointCapture({
    autoSubmitForm: true,
  });

  const onUpdatePoint = useCallback<FineTuneOnUpdatePointCallback>(
    (options: FineTuneOnUpdatePointOptions) => {
      onCapture(options.waypoint, options.qnear);
    },
    [onCapture]
  );

  return (
    <FlowItemBaseAction
      icon={locateOutline}
      label={
        isAwaitingCapture
          ? getLocalizedText('common:cancel')
          : getLocalizedText('common:touch_up')
      }
      iconPlaceholder={
        isAwaitingCapture && (
          <CaptureWaypointSpinner
            onCapture={(waypoint: Waypoint, qnear: QNear) => {
              setWaitForCapture(false);
              onCapture(waypoint, qnear);
            }}
          />
        )
      }
      onClick={() => {
        flowAnalyticService.trackTouchUpPointClicked();
        setBack(
          <FlowItemFineTune
            item={item}
            dismiss={() => showBack(false)}
            onUpdatePoint={onUpdatePoint}
            stopProgramFirst={stopProgramFirst}
          />,
          true
        );
      }}
      disabled={disabled}
    />
  );
};

export { FlowItemTouchUpPointAction };
